import { render, staticRenderFns } from "./ProductProvider.vue?vue&type=template&id=1c3b6866&scoped=true&"
import script from "./ProductProvider.vue?vue&type=script&lang=js&"
export * from "./ProductProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3b6866",
  null
  
)

export default component.exports